(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  var drawer = null;
  var isOpen = false;
  var isBusy = false;

  function init() {
    drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    bindEvents();
    initTimers();
  }

function openDrawer() {
  if (!drawer) return;
  if (isOpen) return; // ← already open, do nothing
  var sbWidth = window.innerWidth - document.documentElement.clientWidth;
  drawer.removeAttribute('hidden');
  isOpen = true;
  document.body.style.overflow = 'hidden';
  document.body.style.paddingRight = sbWidth > 0 ? sbWidth + 'px' : '';
  var closeBtn = $('[data-cart-drawer-close]', drawer);
  if (closeBtn) closeBtn.focus();
  initTimers();
}

  function closeDrawer() {
    if (!drawer) return;
    isOpen = false;
    drawer.setAttribute('hidden', '');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  function refreshDrawer() {
    if (!drawer) return Promise.resolve();
    return fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc  = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-cart-drawer]');
        if (!next) return;
        if (!isOpen) {
          next.setAttribute('hidden', '');
        } else {
          next.removeAttribute('hidden');
        }
        drawer.replaceWith(next);
        drawer = next;
        animateItemsIn();
        document.dispatchEvent(new CustomEvent('cartDrawerRefreshed'));
        initTimers();
      });
  }

function showLoading(message) {
  if (!drawer) return;
  var panel = $('.cart-drawer__panel', drawer);
  if (!panel) return;
  var msg = message || drawer.getAttribute('data-adding-text') || 'Adding to cart\u2026';
  var existing = $('.cart-drawer__loading', panel);
  if (!existing) {
    var el = document.createElement('div');
    el.className = 'cart-drawer__loading';
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="cart-drawer__loading-inner">' +
        '<div class="cart-drawer__spinner"></div>' +
        '<p class="cart-drawer__loading-msg">' + escHtml(msg) + '</p>' +
      '</div>';
    panel.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
  } else {
    existing.querySelector('.cart-drawer__loading-msg').textContent = msg;
  }
  var items = $('.cart-drawer__items', drawer);
  if (items) items.style.opacity = '0.35';
  var upsell = $('.cart-drawer__upsell', drawer);
  if (upsell) upsell.style.opacity = '0.35';
}

function hideLoading() {
  if (!drawer) return;
  var panel = $('.cart-drawer__panel', drawer);
  var el = panel ? $('.cart-drawer__loading', panel) : null;
  if (el) {
    el.classList.remove('is-visible');
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 260);
  }
  var items = $('.cart-drawer__items', drawer);
  if (items) items.style.opacity = '';
  var upsell = $('.cart-drawer__upsell', drawer);
  if (upsell) upsell.style.opacity = '';
}

  function animateItemsIn() {
    if (!drawer) return;
    $$('.cart-drawer__item', drawer).forEach(function (li, i) {
      li.style.animation = 'none';
      li.style.opacity   = '0';
      setTimeout(function () {
        li.style.animation = 'cd-item-in 0.22s ease forwards';
      }, i * 50);
    });
  }

  function animateItemOut(li, cb) {
    var h = li.offsetHeight;
    li.style.transition  = 'opacity 0.18s ease, transform 0.18s ease, max-height 0.24s ease 0.08s, padding 0.24s ease 0.08s, border 0.24s ease 0.08s';
    li.style.overflow    = 'hidden';
    li.style.maxHeight   = h + 'px';
    li.style.borderColor = 'transparent';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        li.style.opacity   = '0';
        li.style.transform = 'translateX(-16px)';
        li.style.maxHeight = '0';
        li.style.padding   = '0';
        setTimeout(cb, 300);
      });
    });
  }

  function cartAdd(variantId, quantity, btn) {
    if (isBusy) return Promise.resolve();
    isBusy = true;
    var origText = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    openDrawer();
    showLoading();

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
        return r.json();
      })
      .then(function () {
        return Promise.all([refreshCartCount(), refreshDrawer()]);
      })
      .then(function () {
        hideLoading();
      })
      .catch(function (err) {
        hideLoading();
        showError(err.message || 'Could not add item. Please try again.');
      })
      .finally(function () {
        isBusy = false;
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = origText; }
      });
  }

  function cartChange(payload, li) {
    if (isBusy) return Promise.resolve();
    isBusy = true;

    var doChange = function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function () { return Promise.all([refreshCartCount(), refreshDrawer()]); })
        .finally(function () { isBusy = false; });
    };

    if (payload.quantity === 0 && li) {
      return new Promise(function (resolve) {
        animateItemOut(li, function () { doChange().then(resolve); });
      });
    }
    return doChange();
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
        $$('[data-cart-count-a11y]').forEach(function (el) {
          el.textContent = cart.item_count + ' items';
        });
        $$('[data-cart-subtotal-btn]').forEach(function (el) {
          try {
            el.textContent = window.Shopify && Shopify.formatMoney
              ? Shopify.formatMoney(cart.total_price, '')
              : cart.currency + (cart.total_price / 100).toFixed(2);
          } catch (e) {}
        });
      });
  }

  function showError(msg) {
    if (!drawer) return;
    var body = $('.cart-drawer__body', drawer);
    if (!body) return;
    var el = document.createElement('p');
    el.className = 'cart-drawer__error';
    el.textContent = msg;
    body.prepend(el);
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 4000);
  }

  function cookieGet(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function cookieSet(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function initTimers() {
    $$('[data-cart-timer]').forEach(function (el) {
      if (el._timerInit) return;
      el._timerInit = true;

      var totalSecs = Number(el.getAttribute('data-cart-timer'));
      if (!totalSecs) return;

      var display = el.querySelector('[data-timer-display]');
      if (!display) return;

      var COOKIE_KEY = 'cart-timer-end-' + totalSecs;

      function getOrResetEnd() {
        var stored = cookieGet(COOKIE_KEY);
        var end    = stored ? Number(stored) : 0;
        if (!end || end - Date.now() <= 0) {
          end = Date.now() + totalSecs * 1000;
          cookieSet(COOKIE_KEY, String(end), 1);
        }
        return end;
      }

      var end = getOrResetEnd();

      function tick() {
        var now  = Date.now();
        var left = Math.floor((end - now) / 1000);
        if (left <= 0) {
          end = Date.now() + totalSecs * 1000;
          cookieSet(COOKIE_KEY, String(end), 1);
          left = totalSecs;
        }
        var m = Math.floor(left / 60);
        var s = left % 60;
        display.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        setTimeout(tick, 1000);
      }

      tick();
    });
  }

  function bindEvents() {

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-open]')) {
        e.preventDefault();
        openDrawer();
      }
    });

    document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-cart-drawer-close]');
    if (el) {
        if (el.tagName !== 'A') e.preventDefault();
        closeDrawer();
    }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) closeDrawer();
    });

    document.addEventListener('submit', function (e) {
      if (e.target.closest('[data-upsell-form]')) return;
      var form = e.target.closest('form[action*="/cart/add"], form[data-product-form], form[data-quick-add]');
      if (!form) return;
      var autoOpen = drawer ? drawer.getAttribute('data-auto-open') !== 'false' : true;
      if (!autoOpen) return;
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return;
      var btn = form.querySelector('[type="submit"]');
      var qty = form.querySelector('[name="quantity"]');
      cartAdd(idInput.value, qty ? Number(qty.value) || 1 : 1, btn);
    });

    document.addEventListener('click', function (e) {
      if (!drawer) return;
      var item = e.target.closest('[data-cart-item]');
      if (!item || !drawer.contains(item)) return;
      var line = Number(item.getAttribute('data-line'));

      if (e.target.closest('[data-qty-increase]')) {
        var v = $('[data-qty-value]', item);
        cartChange({ line: line, quantity: Number(v.textContent) + 1 });
      } else if (e.target.closest('[data-qty-decrease]')) {
        var v2 = $('[data-qty-value]', item);
        var next = Math.max(0, Number(v2.textContent) - 1);
        cartChange({ line: line, quantity: next }, next === 0 ? item : null);
      } else if (e.target.closest('[data-cart-remove]')) {
        cartChange({ line: line, quantity: 0 }, item);
      }
    });

    document.addEventListener('change', function (e) {
      if (!drawer) return;
      var input = e.target.closest('[data-qty-input]');
      if (!input || !drawer.contains(input)) return;
      var item = input.closest('[data-cart-item]');
      var line = Number(item.getAttribute('data-line'));
      var qty  = Math.max(0, Number(input.value) || 0);
      cartChange({ line: line, quantity: qty }, qty === 0 ? item : null);
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-upsell-form]');
      if (!form || !drawer || !drawer.contains(form)) return;
      e.preventDefault();
      var btn = $('button[type="submit"]', form);
      var vid = $('input[name="id"]', form);
      if (!vid) return;
      cartAdd(vid.value, 1, btn);
    });

    document.addEventListener('cartDrawerRefreshed', initTimers);
  }

  window.__foundationCart = {
    open    : openDrawer,
    close   : closeDrawer,
    refresh : refreshDrawer,
    add     : cartAdd
  };

  function escHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();